import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { SearchWrapper } from './styles';
import { ZendeskHelpMobileSearchModal } from './ZendeskHelpMobileSearchModal';
import { toggleChat } from '../../../actions/chatAction';
import { PromoInputSearch } from '../form/PromoInputPhoneWithDropdown/PromoInputSearch';
import { getHelpCenterUrl, useGetQueryParams } from '../utils';

const ZendeskHelpMobileSearch = (props) => {
    const wrapperRef = useRef(null);
    const location = useLocation();
    const urlParams = useGetQueryParams();

    const [fullViewSearch, setFullViewSearch] = useState(false);

    const toggleSearch = (e, show) => {
        e.preventDefault();
        setFullViewSearch(show);
    };

    const chatLink = () => {
        if (location.pathname.includes('showChat')) {
            return getHelpCenterUrl(`${location.pathname}`, urlParams);
        }
        return getHelpCenterUrl(`${location.pathname}/showChat`, urlParams);
    };

    const handleToggleChat = () => {
        if (!urlParams.platform) {
            props.toggleChat(true);
        }
    };

    return (
        <SearchWrapper ref={wrapperRef}>
            <PromoInputSearch placeholder={props.searchPlaceholder} toggle={toggleSearch} />
            {fullViewSearch && (
                <>
                    <ZendeskHelpMobileSearchModal
                        sections={props.sections}
                        lang={props.lang}
                        country={props.country}
                        searchPlaceholder={props.searchPlaceholder}
                        searchNoResult={props.searchNotFound}
                        chatButton={props.chatButton}
                        chatButtonType={urlParams.platform ? 'link' : null}
                        chatButtonHref={urlParams.platform ? chatLink() : null}
                        toggleChat={() => handleToggleChat()}
                        toggleSearch={(e) => toggleSearch(e, false)}
                        useThemeColor
                    />
                </>
            )}
        </SearchWrapper>
    );
};

const mapStateToProps = ({ extra }) => {
    return {
        sections: extra?.zendeskHelpData?.sections,
        searchPlaceholder: extra?.strapiApi?.search_placeholder,
        searchNotFound: extra?.strapiApi?.search_not_found_mobile,
        chatButton: extra?.strapiApi?.chat_btn_mobile,
        lang: extra.noAuthFooter?.language?.lang,
        country: extra.noAuthFooter?.language?.country,
    };
};

export default connect(mapStateToProps, { toggleChat })(ZendeskHelpMobileSearch);
